/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';
import { Field } from 'redux-form';
import { RenderSelect2 } from 'src/components/views/common/forms/render-select-2-v2';
import RenderColorPickerItem from 'src/components/views/common/render-color-picker-item';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import {
  PRODUCT_ITEM_BORDER_LAYOUT_VALUE,
  PRODUCT_ITEM_BORDER_LAYOUT_OPTIONS
} from 'src/constants/theme-settings';
import { DropdownIndicator, styles } from './react-select-style';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductItemForm extends Component<ComposedProps> {
  render() {
    const { i18n, prefix, formValues, updateField } = this.props;
    const formattedBorderLayoutSelect = PRODUCT_ITEM_BORDER_LAYOUT_OPTIONS.map(function (option) {
      return {
        ...option,
        label: i18n.translate(option.label)
      };
    });

    const borderLayout = _.get(formValues, `${prefix}.borderLayout`, '');
    const backgroundColor = _.get(formValues, `${prefix}.backgroundColor`, '');
    const backgroundColorHover = _.get(formValues, `${prefix}.backgroundColorOnHover`, '');
    const borderColor = _.get(formValues, `${prefix}.borderColor`, '');
    const borderColorHover = _.get(formValues, `${prefix}.borderColorOnHover`, '');
    let colorPickerList = [
      {
        colorValue: backgroundColor,
        fieldName: `${prefix}.backgroundColor`,
        fieldLabel: i18n.translate('AdminHTML.ThemeSetting.Form.productItem_BackgroundColor_Item')
      },
      {
        colorValue: backgroundColorHover,
        fieldName: `${prefix}.backgroundColorOnHover`,
        fieldLabel: i18n.translate(
          'AdminHTML.ThemeSetting.Form.productItem_BackgroundColorHover_Item'
        )
      }
    ];

    if (borderLayout !== PRODUCT_ITEM_BORDER_LAYOUT_VALUE.NO_BORDER) {
      const borderColorArr = [
        {
          colorValue: borderColor,
          fieldName: `${prefix}.borderColor`,
          fieldLabel: i18n.translate('AdminHTML.ThemeSetting.Form.productItem_BorderColor_Item')
        },
        {
          colorValue: borderColorHover,
          fieldName: `${prefix}.borderColorOnHover`,
          fieldLabel: i18n.translate(
            'AdminHTML.ThemeSetting.Form.productItem_BorderColorHover_Item'
          )
        }
      ];
      colorPickerList = [...colorPickerList, ...borderColorArr];
    }

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.productItem_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['CustomizingProductItemSection']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <Field
          name={`${prefix}.borderLayout`}
          label={i18n.translate('AdminHTML.ThemeSetting.Form.productItem_BorderLayout_Title')}
          options={formattedBorderLayoutSelect}
          component={RenderSelect2}
          components={{ DropdownIndicator }}
          styles={styles}
          isSearchable={false}
        />

        <div className="form-section">
          <p className="title">{i18n.translate('AdminHTML.ThemeSetting.Form.color_Title')}</p>
          {colorPickerList.map((item, index) => (
            <RenderColorPickerItem
              key={index}
              colorValue={item.colorValue}
              fieldName={item.fieldName}
              fieldLabel={item.fieldLabel}
              updateField={updateField}
            />
          ))}
        </div>
      </FormLayout>
    );
  }
}

export default withI18n()(ProductItemForm);
